<template>
    <div class="section-block right-block">
        <div class="section-title">已生效文书</div>
        <el-scrollbar class="doc-list-scrollbar" v-loading="listLoading">
            <div v-if="effectiveList.length" class="doc-list">
                <div
                    v-for="(item, index) in effectiveList"
                    :key="item.id || index"
                    class="doc-item"
                >
                    <div class="doc-item-icon">
                        <img src="@/assets/images/Investigation/transcript.png" alt="文书" class="doc-icon" />
                    </div>
                    <div class="doc-item-body">
                        <div class="doc-item-title">{{ item.documentTypeLabel || item.title || '文书' }}</div>
                        <div class="doc-item-time">上传时间: {{ item.createTime || item.uploadTime || '-' }}</div>
                        <div class="doc-item-actions">
                            <el-button type="primary" link size="small" @click="handleView(item)">查看</el-button>
                            <el-button type="success" link size="small" @click="handleDownload(item)">下载</el-button>
                            <el-button type="danger" link size="small" @click="handleDelete(item)">删除</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="doc-empty">暂无已生效文书</div>
        </el-scrollbar>
    </div>
</template>

<script>
export default {
    name: 'EffectiveDocList',
    data() {
        return {
            listLoading: false,
            effectiveList: []
        }
    },
    created() {
        this.loadEffectiveList()
    },
    methods: {
        loadEffectiveList() {
            this.listLoading = true
            setTimeout(() => {
                this.effectiveList = [
                    {
                        id: 1,
                        documentType: '1',
                        documentTypeLabel: '工伤认定决定书',
                        fileUrl: '',
                        createTime: '2025-01-18'
                    },
                    {
                        id: 2,
                        documentType: '2',
                        documentTypeLabel: '举证通知书',
                        fileUrl: '',
                        createTime: '2025-01-18'
                    }
                ]
                this.listLoading = false
            }, 200)
        },
        resolvePreviewUrl(url) {
            if (!url) return ''
            if (url.startsWith('http')) return url
            return (this.imageUrlprefix || process.env.VUE_APP_IMAGEURLPREFIX || '') + url
        },
        handleView(item) {
            if (!item) return
            const url = item.fileUrl || item.url
            if (!url) {
                this.$message.warning('该文书暂无预览地址')
                return
            }
            window.open(this.resolvePreviewUrl(url), '_blank')
        },
        handleDownload(item) {
            if (!item || !(item.fileUrl || item.url)) {
                this.$message.warning('暂无文件地址')
                return
            }
            const url = this.resolvePreviewUrl(item.fileUrl || item.url)
            window.open(url, '_blank')
        },
        handleDelete(item) {
            this.$confirm('确认删除该文书？', '提示', { type: 'warning' })
                .then(() => {
                    this.effectiveList = this.effectiveList.filter(
                        (r) => (r.id || r) !== (item.id || item)
                    )
                    this.$message.success('删除成功')
                })
                .catch(() => {})
        }
    }
}
</script>

<style lang="scss" scoped>
.section-block {
    margin-bottom: 0;
    background: #fff;
    border-radius: 4px;
    padding: 20px;

    .section-title {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        padding-left: 11px;
        margin-bottom: 12px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 12px;
            border-radius: 20px;
            background: var(--vt-c-blue, #409eff);
        }
    }
}

.right-block .section-title {
    flex-shrink: 0;
}

.doc-list-scrollbar {
    min-height: 200px;
    max-height: 320px;

    :deep(.el-scrollbar__wrap) {
        overflow-x: hidden;
    }
}

.doc-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.doc-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.doc-item-icon {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
}

.doc-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.doc-item-body {
    flex: 1;
    min-width: 0;
}

.doc-item-title {
    font-weight: 500;
    color: #303133;
    font-size: 14px;
    margin-bottom: 6px;
}

.doc-item-time {
    font-size: 13px;
    color: #606266;
    margin-bottom: 8px;
}

.doc-item-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}

.doc-empty {
    text-align: center;
    color: #909399;
    padding: 60px 0;
    font-size: 14px;
}
</style>
